// Review of Adjustments
export const HrManager = "HrManager";
export const EmployeeSeen = "EmployeeSeen";
export const DateOfBirth = "Dob";
export const EmployeeId = "EmployeeId";
export const EmployerAndDivision = "EmployerAndDivision";
export const JobTitle = "JobTitle";
export const NotesFromMeetingUploaded = "NotesFromMeetingUploaded";
export const DateOfMeeting = "DateOfMeeting";
export const IsAssociateReadyToReturnToNormalWorking = "IsAssociateReadyToReturnToNormalWorking";
export const HasAnExtendedWorkAdjustmentBeenAgreed = "HasAnExtendedWorkAdjustmentBeenAgreed";

// New Adjustment Details

// Adjustments mini-section 0
export const StartDateOfAdjustment0 = "StartDateOfAdjustment0";
export const EndDateOfAdjustment0 = "EndDateOfAdjustment0";
export const ShiftType0 = "ShiftType0";
export const DaysPlannedForWork0 = "DaysPlannedForWork0";
export const StartTime0 = "StartTime0";
export const EndTime0 = "EndTime0";
export const IsThisPatternTheSameForTheWholeWorkAdjustment0 = "IsThisPatternTheSameForTheWholeWorkAdjustment0";

// Adjustments mini-section 1
export const StartDateOfAdjustment1 = "StartDateOfAdjustment1";
export const EndDateOfAdjustment1 = "EndDateOfAdjustment1";
export const ShiftType1 = "ShiftType1";
export const DaysPlannedForWork1 = "DaysPlannedForWork1";
export const StartTime1 = "StartTime1";
export const EndTime1 = "EndTime1";
export const IsThisPatternTheSameForTheWholeWorkAdjustment1 = "IsThisPatternTheSameForTheWholeWorkAdjustment1";

// Adjustments mini-section 2
export const StartDateOfAdjustment2 = "StartDateOfAdjustment2";
export const EndDateOfAdjustment2 = "EndDateOfAdjustment2";
export const ShiftType2 = "ShiftType2";
export const DaysPlannedForWork2 = "DaysPlannedForWork2";
export const StartTime2 = "StartTime2";
export const EndTime2 = "EndTime2";
export const IsThisPatternTheSameForTheWholeWorkAdjustment2 = "IsThisPatternTheSameForTheWholeWorkAdjustment2";

// Adjustments mini-section 3
export const StartDateOfAdjustment3 = "StartDateOfAdjustment3";
export const EndDateOfAdjustment3 = "EndDateOfAdjustment3";
export const ShiftType3 = "ShiftType3";
export const DaysPlannedForWork3 = "DaysPlannedForWork3";
export const StartTime3 = "StartTime3";
export const EndTime3 = "EndTime3";
export const IsThisPatternTheSameForTheWholeWorkAdjustment3 = "IsThisPatternTheSameForTheWholeWorkAdjustment3";

// Adjustments mini-section 4
export const StartDateOfAdjustment4 = "StartDateOfAdjustment4";
export const EndDateOfAdjustment4 = "EndDateOfAdjustment4";
export const ShiftType4 = "ShiftType4";
export const DaysPlannedForWork4 = "DaysPlannedForWork4";
export const StartTime4 = "StartTime4";
export const EndTime4 = "EndTime4";
export const IsThisPatternTheSameForTheWholeWorkAdjustment4 = "IsThisPatternTheSameForTheWholeWorkAdjustment4";

// Adjustments mini-section 5
export const StartDateOfAdjustment5 = "StartDateOfAdjustment5";
export const EndDateOfAdjustment5 = "EndDateOfAdjustment5";
export const ShiftType5 = "ShiftType5";
export const DaysPlannedForWork5 = "DaysPlannedForWork5";
export const StartTime5 = "StartTime5";
export const EndTime5 = "EndTime5";
export const IsThisPatternTheSameForTheWholeWorkAdjustment5 = "IsThisPatternTheSameForTheWholeWorkAdjustment5";

// Adjustments mini-section 6
export const StartDateOfAdjustment6 = "StartDateOfAdjustment6";
export const EndDateOfAdjustment6 = "EndDateOfAdjustment6";
export const ShiftType6 = "ShiftType6";
export const DaysPlannedForWork6 = "DaysPlannedForWork6";
export const StartTime6 = "StartTime6";
export const EndTime6 = "EndTime6";
export const IsThisPatternTheSameForTheWholeWorkAdjustment6 = "IsThisPatternTheSameForTheWholeWorkAdjustment6";

// Adjustments mini-section 7
export const StartDateOfAdjustment7 = "StartDateOfAdjustment7";
export const EndDateOfAdjustment7 = "EndDateOfAdjustment7";
export const ShiftType7 = "ShiftType7";
export const DaysPlannedForWork7 = "DaysPlannedForWork7";
export const StartTime7 = "StartTime7";
export const EndTime7 = "EndTime7";
export const IsThisPatternTheSameForTheWholeWorkAdjustment7 = "IsThisPatternTheSameForTheWholeWorkAdjustment7";

// Adjustments mini-section 8
export const StartDateOfAdjustment8 = "StartDateOfAdjustment8";
export const EndDateOfAdjustment8 = "EndDateOfAdjustment8";
export const ShiftType8 = "ShiftType8";
export const DaysPlannedForWork8 = "DaysPlannedForWork8";
export const StartTime8 = "StartTime8";
export const EndTime8 = "EndTime8";
export const IsThisPatternTheSameForTheWholeWorkAdjustment8 = "IsThisPatternTheSameForTheWholeWorkAdjustment8";

// Adjustments mini-section 9
export const StartDateOfAdjustment9 = "StartDateOfAdjustment9";
export const EndDateOfAdjustment9 = "EndDateOfAdjustment9";
export const ShiftType9 = "ShiftType9";
export const DaysPlannedForWork9 = "DaysPlannedForWork9";
export const StartTime9 = "StartTime9";
export const EndTime9 = "EndTime9";
export const IsThisPatternTheSameForTheWholeWorkAdjustment9 = "IsThisPatternTheSameForTheWholeWorkAdjustment9";

// Adjustments mini-section 10
export const StartDateOfAdjustment10 = "StartDateOfAdjustment10";
export const EndDateOfAdjustment10 = "EndDateOfAdjustment10";
export const ShiftType10 = "ShiftType10";
export const DaysPlannedForWork10 = "DaysPlannedForWork10";
export const StartTime10 = "StartTime10";
export const EndTime10 = "EndTime10";
export const IsThisPatternTheSameForTheWholeWorkAdjustment10 = "IsThisPatternTheSameForTheWholeWorkAdjustment10";

// Adjustments mini-section 11
export const StartDateOfAdjustment11 = "StartDateOfAdjustment11";
export const EndDateOfAdjustment11 = "EndDateOfAdjustment11";
export const ShiftType11 = "ShiftType11";
export const DaysPlannedForWork11 = "DaysPlannedForWork11";
export const StartTime11 = "StartTime11";
export const EndTime11 = "EndTime11";
export const IsThisPatternTheSameForTheWholeWorkAdjustment11 = "IsThisPatternTheSameForTheWholeWorkAdjustment11";

// Adjustments mini-section 12
export const StartDateOfAdjustment12 = "StartDateOfAdjustment12";
export const EndDateOfAdjustment12 = "EndDateOfAdjustment12";
export const ShiftType12 = "ShiftType12";
export const DaysPlannedForWork12 = "DaysPlannedForWork12";
export const StartTime12 = "StartTime12";
export const EndTime12 = "EndTime12";
export const IsThisPatternTheSameForTheWholeWorkAdjustment12 = "IsThisPatternTheSameForTheWholeWorkAdjustment12";

// Adjustments mini-section 13
export const StartDateOfAdjustment13 = "StartDateOfAdjustment13";
export const EndDateOfAdjustment13 = "EndDateOfAdjustment13";
export const ShiftType13 = "ShiftType13";
export const DaysPlannedForWork13 = "DaysPlannedForWork13";
export const StartTime13 = "StartTime13";
export const EndTime13 = "EndTime13";
export const IsThisPatternTheSameForTheWholeWorkAdjustment13 = "IsThisPatternTheSameForTheWholeWorkAdjustment13";

// Adjustments mini-section 14
export const StartDateOfAdjustment14 = "StartDateOfAdjustment14";
export const EndDateOfAdjustment14 = "EndDateOfAdjustment14";
export const ShiftType14 = "ShiftType14";
export const DaysPlannedForWork14 = "DaysPlannedForWork14";
export const StartTime14 = "StartTime14";
export const EndTime14 = "EndTime14";
export const IsThisPatternTheSameForTheWholeWorkAdjustment14 = "IsThisPatternTheSameForTheWholeWorkAdjustment14";

// Adjustments mini-section 15
export const StartDateOfAdjustment15 = "StartDateOfAdjustment15";
export const EndDateOfAdjustment15 = "EndDateOfAdjustment15";
export const ShiftType15 = "ShiftType15";
export const DaysPlannedForWork15 = "DaysPlannedForWork15";
export const StartTime15 = "StartTime15";
export const EndTime15 = "EndTime15";
export const IsThisPatternTheSameForTheWholeWorkAdjustment15 = "IsThisPatternTheSameForTheWholeWorkAdjustment15";

// Adjustments mini-section 16
export const StartDateOfAdjustment16 = "StartDateOfAdjustment16";
export const EndDateOfAdjustment16 = "EndDateOfAdjustment16";
export const ShiftType16 = "ShiftType16";
export const DaysPlannedForWork16 = "DaysPlannedForWork16";
export const StartTime16 = "StartTime16";
export const EndTime16 = "EndTime16";
export const IsThisPatternTheSameForTheWholeWorkAdjustment16 = "IsThisPatternTheSameForTheWholeWorkAdjustment16";

// Adjustments mini-section 17
export const StartDateOfAdjustment17 = "StartDateOfAdjustment17";
export const EndDateOfAdjustment17 = "EndDateOfAdjustment17";
export const ShiftType17 = "ShiftType17";
export const DaysPlannedForWork17 = "DaysPlannedForWork17";
export const StartTime17 = "StartTime17";
export const EndTime17 = "EndTime17";
export const IsThisPatternTheSameForTheWholeWorkAdjustment17 = "IsThisPatternTheSameForTheWholeWorkAdjustment17";

// Adjustments mini-section 18
export const StartDateOfAdjustment18 = "StartDateOfAdjustment18";
export const EndDateOfAdjustment18 = "EndDateOfAdjustment18";
export const ShiftType18 = "ShiftType18";
export const DaysPlannedForWork18 = "DaysPlannedForWork18";
export const StartTime18 = "StartTime18";
export const EndTime18 = "EndTime18";
export const IsThisPatternTheSameForTheWholeWorkAdjustment18 = "IsThisPatternTheSameForTheWholeWorkAdjustment18";

// Adjustments mini-section 19
export const StartDateOfAdjustment19 = "StartDateOfAdjustment19";
export const EndDateOfAdjustment19 = "EndDateOfAdjustment19";
export const ShiftType19 = "ShiftType19";
export const DaysPlannedForWork19 = "DaysPlannedForWork19";
export const StartTime19 = "StartTime19";
export const EndTime19 = "EndTime19";

export const ExpectedReturnToWorkDateIfKnown = "ExpectedReturnToWorkDateIfKnown";
export const WorkAdjustmentReviewDate = "WorkAdjustmentReviewDate";

// Closure of Adjustments
export const CloseThisWorkAdjustmentCase = "CloseThisWorkAdjustmentCase";
export const ReasonForClosure = "ReasonForClosure";
export const DateOfClosure = "DateOfClosure";
export const NotesFromClosure = "NotesFromClosure";

// Re-referral
export const ConfirmYouWishToRequestReReferral = "ConfirmYouWishToRequestReReferral";
export const ReReferralDetails = "ReReferralDetails";
export const TypeOfAppointmentRequested = "TypeOfAppointmentRequested";
